module.exports = __webpack_public_path__ + "media/images/btn_change_station-1dad5f5620fea9d84b0e238493681ff9.gif";